import api from "@/api/api-v1-config";

export async function getAllocationListAxios() {    
    return await api.get("v1/hrms/employeeallocation?pageNumber=1&pageSize=10000");
}

export async function postImportAllocationAxios(payload) {    
    return await api.post("v1/uploads/importallocations", payload);
}

export async function postAllocationAxios(allocation) {    
    return await api.post("v1/hrms/employeeallocation", allocation);
}

export async function putAllocationAxios(allocation) {    
    return await api.put("v1/hrms/employeeallocation/", allocation);
}

export async function deleteAllocationAxios(id) {    
    return await api.delete("v1/hrms/employeeallocation/" + id);
}

export async function getPayrollListAxios(allocationDate, employeeId) {    
    return await api.get(`v1/hrms/payrollallocation?allocationDate=${allocationDate}&employeeId=${employeeId}`);
}

export async function getEmployeePayrollAxios(employeeId) {    
    return await api.get(`v1/hrms/employeepayroll?Id=${employeeId}`);
}
// export async function getPayrollListAxios(allocationDate) {    
//     return await api.get(`v1/hrms/payrollallocation?allocationDate=${allocationDate}`);
// }

export async function postPayrollAxios(allocationDate) {    
    return await api.post(`v1/hrms/payrollallocation`, allocationDate);
}

// export async function getPayrollExportAxios(allocationDate) {    
//     return await api.get(`v1/hrms/exportpayroll?allocationDate=${allocationDate}`);
// }

export async function getPayrollExportAxios(allocationDate) {
    return await api.get(`v1/hrms/exportpayroll?allocationDate=${allocationDate}`);
  }